import { render } from "./TaxId.vue?vue&type=template&id=591561c5&ts=true"
import script from "./TaxId.vue?vue&type=script&lang=ts"
export * from "./TaxId.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__